import styles from './LoadingSpinner.module.css';

interface Props {
  fullScreen?: boolean;
}

export const LoadingSpinner = ({ fullScreen = false }: Props) => (
  <div className={`${styles.wrapper} ${fullScreen ? styles.fullScreen : ''}`}>
    <div className={styles.spinner} role="status" aria-label="Loading" />
  </div>
);
